import React from "react";
import {
    Container,
    Content,
    Description,
    Hero,
    SignIn,
    SignInContainer,
    Title,
} from "@Styled/Pages/ForgotPassword";
import { ForgotPasswordForm, Header } from "@Components";
import { IForgotPassword } from "@Interfaces";
import { useTranslation } from "react-i18next";

const ForgotPassword: React.FC<IForgotPassword.IProps> = () => {
    const { t } = useTranslation();
    const [sendAction, setSendAction] = React.useState(false);
    const handleSendAction = (sendActionData: boolean) => {
        setSendAction(sendActionData);
    };
    return (
        <>
            <Hero>
                <Header showNav={false} showJoinButton={true} />
                <Container>
                    <Content>
                        <Title>
                            {sendAction
                                ? t("pages.forgot_password.title1")
                                : t("pages.forgot_password.title2")}
                        </Title>
                        <Description>
                            {sendAction
                                ? t("pages.forgot_password.subtitle1")
                                : t("pages.forgot_password.subtitle2")}
                        </Description>
                    </Content>
                    <SignIn>
                        <SignInContainer>
                            <ForgotPasswordForm
                                onSendAction={handleSendAction}
                            />
                        </SignInContainer>
                    </SignIn>
                </Container>
            </Hero>
        </>
    );
};

export default ForgotPassword;
